/* eslint-disable no-unused-vars */
import { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import { isMobileOnly } from 'react-device-detect';
import PdfView from './DropzoneArea/PdfView';
import Dropzone from './DropzoneArea/Dropzone';
import { ReactComponent as FrontOfId } from '../assets/images/svg/front-of-card.svg';
import Paragraph from './Paragraph/Paragraph';
import themeColors from '../assets/styles/themeColors';
import { variables } from '../assets/styles/variables';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const DragContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: ${variables.borderRadius.borderRadiusMd};
  border: 1px dashed ${themeColors.colorBorderPrimaryDark};
  background: ${themeColors.colorBackgroundDropzone};
  text-align: center;
  padding: 0.75rem;
  cursor: pointer;

  svg {
    max-height: 93px;
    margin-bottom: 1.5rem;
  }
`;

const Image = styled.img`
  object-fit: contain;
  width: 100%;
  height: 100%;
  max-height: 17.5rem;
`;

const DropzoneText = ({ pdfFormatDisabled }) => {
  const { t } = useTranslation();

  return (
    <>
      <Paragraph mb={12}>
        {isMobileOnly
          ? t('kycVerification.dropHereMobile')
          : t('kycVerification.dropHere')}
      </Paragraph>
      <Paragraph variant="small" color={themeColors.colorTextXLLight}>
        {pdfFormatDisabled
          ? t('kycVerification.supportsWothoutPdf')
          : t('kycVerification.supports')}
      </Paragraph>
    </>
  );
};

const DropzoneArea = ({
  onUpload,
  frontSide,
  pdfFormatDisabled,
  isPassport,
}) => {
  const { t } = useTranslation();
  const [imageUrl, setImageUrl] = useState(null);
  const [pdfUrl, setPdfUrl] = useState(null);

  return (
    <Container>
      <DragContainer hasData={pdfUrl || imageUrl}>
        {imageUrl && <Image src={imageUrl} alt="" />}
        {pdfUrl && <PdfView pdfUrl={pdfUrl} />}
        {!imageUrl && !pdfUrl && (
          <>
            {frontSide && <FrontOfId />}
            {isPassport && <FrontOfId />}
            <DropzoneText pdfFormatDisabled={pdfFormatDisabled} />
          </>
        )}
        <Dropzone
          setImageUrl={setImageUrl}
          setPdfUrl={setPdfUrl}
          onUpload={onUpload}
          pdfFormatDisabled={pdfFormatDisabled}
        />
      </DragContainer>
      {frontSide && (
        <Paragraph mt={24} fontWeight={600}>
          {t('kycVerification.front')}
        </Paragraph>
      )}
    </Container>
  );
};

DropzoneArea.propTypes = {
  onUpload: PropTypes.func,
  frontSide: PropTypes.bool,
  pdfFormatDisabled: PropTypes.bool,
  isPassport: PropTypes.bool,
};
DropzoneText.propTypes = {
  pdfFormatDisabled: PropTypes.bool,
};

export default DropzoneArea;
